// extracted by mini-css-extract-plugin
var _1 = "e05e18";
export { _1 as "hidden" }
